import http from './axios/httpRequest';

const IMAGE_URL_MEMORY_CACHE_TIME_MS = 5 * 60 * 1000;

const imageUrlCache = new Map();

export const normalizeAwsId = (awsId) => {
    if (awsId === null || awsId === undefined || awsId === '') return undefined;
    return String(awsId);
};

export const resolveImageVariant = ({ usage, width, height } = {}) => {
    if (usage === 'download') return 'NATIVE';
    if (usage === 'viewer' || usage === 'hero-cover') return 'LOW';
    if (usage === 'thumb') return 'HIGH';
    if (usage === 'card-cover') return 'MEDIUM';

    const longestSide = Math.max(width ?? 0, height ?? 0);

    if (usage === 'avatar') {
        return longestSide > 64 ? 'MEDIUM' : 'HIGH';
    }

    if (usage === 'editor') {
        return longestSide > 700 ? 'LOW' : 'MEDIUM';
    }

    if (longestSide > 700) return 'LOW';
    if (longestSide > 100) return 'MEDIUM';
    return 'HIGH';
};

export const getAwsImageVariantUrl = async (awsId, variant) => {
    const cacheKey = `${awsId}:${variant}`;
    const cached = imageUrlCache.get(cacheKey);

    if (cached && cached.expiresAt > Date.now()) return cached.request;
    if (cached) imageUrlCache.delete(cacheKey);

    const request = http
        .get(`/bff/upload-bff/editor-image/${awsId}`, {
            params: { variant }
        })
        .then((response) => response.data);

    imageUrlCache.set(cacheKey, {
        expiresAt: Date.now() + IMAGE_URL_MEMORY_CACHE_TIME_MS,
        request
    });

    try {
        return await request;
    } catch (error) {
        imageUrlCache.delete(cacheKey);
        throw error;
    }
};

export const clearAwsImageUrlCache = (awsId, variant) => {
    if (awsId !== undefined && variant) {
        imageUrlCache.delete(`${awsId}:${variant}`);
        return;
    }
    imageUrlCache.clear();
};
